import React, { FC } from 'react'

import { ArrowRightIcon, IconSizes } from '@inno-ui/icons'
import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'

import styles from './FullTourStepEight.module.scss'
import fundingPotentialDe from './assets/funding-potential-de.png'
import fundingPotentialEn from './assets/funding-potential-en.png'

export const FullTourStepEight: FC = () => {
  const { i18n, t } = useTranslation('translation', {
    keyPrefix: 'desktop.full_tour.step_eight'
  })
  const pathChips = t('path_chips', { returnObjects: true }) as string[]
  const currentDate = dayjs()
  const fundingYear = currentDate.year() - 4
  const fundingDeadline = currentDate
    .endOf('year')
    .subtract(2, 'month')
    .endOf('month')
  const deadlineFormat = i18n.language?.startsWith('zh')
    ? 'YYYY 年 M 月 D 日'
    : i18n.language?.startsWith('de') || i18n.language?.startsWith('en')
      ? 'DD.MM.YYYY'
      : 'DD/MM/YYYY'
  const fundingPotentialImage = i18n.language?.startsWith('de')
    ? fundingPotentialDe
    : fundingPotentialEn

  return (
    <section
      className={styles.tourCard}
      role='dialog'
      aria-modal='true'
      aria-labelledby='full-tour-step-eight-title'
      aria-describedby='full-tour-step-eight-description'
    >
      <div className={styles.tourMain}>
        <div className={styles.tourLeft}>
          <div className={styles.tourHeading}>
            <p className={styles.tourEyebrow}>{t('eyebrow')}</p>
            <h1 id='full-tour-step-eight-title' className={styles.tourTitle}>
              <span>{t('title_before')}</span>
              <span className={styles.titleHighlight}>
                {t('title_highlighted')}
              </span>
            </h1>
          </div>

          <div className={styles.tourDetails}>
            <nav className={styles.path} aria-label={t('path_label')}>
              {pathChips.map((chip, index) => (
                <React.Fragment key={chip}>
                  {index > 0 && (
                    <ArrowRightIcon
                      aria-hidden='true'
                      color='var(--white)'
                      size={IconSizes.Size16}
                    />
                  )}
                  <span className={styles.pathChip}>{chip}</span>
                </React.Fragment>
              ))}
            </nav>

            <div
              id='full-tour-step-eight-description'
              className={styles.tourDescription}
            >
              <p>
                {t('description_before')}{' '}
                <strong>
                  {t('description_highlighted', {
                    year: fundingYear,
                    date: fundingDeadline.format(deadlineFormat)
                  })}
                </strong>
              </p>
              <p>{t('description_after')}</p>
            </div>
          </div>
        </div>

        <div className={styles.visualColumn}>
          <div className={styles.visualCard}>
            <div
              className={`${styles.preview} ${
                i18n.language?.startsWith('de') ? styles.previewGerman : ''
              }`}
            >
              <img
                src={fundingPotentialImage}
                alt={t('image_alt')}
                className={styles.previewImage}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
